(() => {
  if (window.__meborePdpEventsInitialized) return;
  window.__meborePdpEventsInitialized = true;

  const NS = 'mebore';
  const pushEvent = (ga4Event, params) => {
    const payload = {
      ga4_event: ga4Event,
      brand: "MEN'S MEBORE",
      page_type: 'mens_pdp',
      ...params
    };
    const name = `${NS}:${ga4Event}`;
    try { window.Shopify?.analytics?.publish?.(name, payload); } catch (_) {}
    try { (window.__meborePdpEvents ||= []).push({ name, payload }); } catch (_) {}
  };

  const number = value => {
    const parsed = Number.parseFloat(String(value || '').replace(/[^0-9.]/g, ''));
    return Number.isFinite(parsed) ? parsed : 0;
  };

  const visible = root => [...root.querySelectorAll('[data-mn-item-id]')]
    .filter(element => (
      element.offsetParent !== null
      && window.getComputedStyle(element).display !== 'none'
    ));

  const p1Item = element => ({
    item_id: element.dataset.mnItemId || '',
    item_name: element.dataset.mnItemName || '',
    price: number(element.dataset.mnPrice),
    index: Number.parseInt(element.dataset.mnIndex || '0', 10),
    item_brand: "MEN'S MEBORE",
    related_source: element.dataset.mnRelatedSource || 'unknown',
    season_demoted: element.dataset.mnSeasonDemoted || 'unknown'
  });

  const observeOnce = (root, callback) => {
    if (!root) return;
    if (!('IntersectionObserver' in window)) {
      callback();
      return;
    }
    const observer = new IntersectionObserver(entries => {
      if (!entries[0]?.isIntersecting) return;
      callback();
      observer.unobserve(root);
    }, { threshold: 0.25 });
    observer.observe(root);
  };

  const initP1 = () => {
    const root = document.querySelector('[data-mn-list-root="mens_pdp_p1"]');
    if (!root) return;

    observeOnce(root, () => {
      pushEvent('view_item_list', {
        item_list_id: 'mens_pdp_p1',
        item_list_name: 'この商品に近いアイテム',
        gate: root.dataset.mnGate || 'unknown',
        seed_item_id: root.dataset.mnSeedItemId || '',
        items: visible(root).map(p1Item)
      });
    });

    root.addEventListener('click', event => {
      const card = event.target.closest('[data-mn-list="mens_pdp_p1"]');
      if (!card || !event.target.closest('a[href*="/products/"]')) return;
      pushEvent('select_item', {
        item_list_id: 'mens_pdp_p1',
        item_list_name: 'この商品に近いアイテム',
        gate: root.dataset.mnGate || 'unknown',
        seed_item_id: root.dataset.mnSeedItemId || '',
        items: [p1Item(card)]
      });
    }, { capture: true });
  };

  const handleFromUrl = href => {
    const tail = String(href || '').split('/products/')[1] || '';
    return tail.split(/[/?#]/)[0] || '';
  };

  const rankItem = (card, index) => {
    const link = card.querySelector('a.full-unstyled-link[href*="/products/"]');
    const priceElement = card.querySelector('.price-item--sale') || card.querySelector('.price-item--regular');
    return {
      element: card,
      link,
      item: {
        item_id: handleFromUrl(link?.getAttribute('href')),
        item_name: link?.textContent?.trim() || '',
        price: number(priceElement?.textContent),
        index,
        item_brand: "MEN'S MEBORE"
      }
    };
  };

  const initRanking = () => {
    const rankRoot = document.querySelector(
      '[id^="shopify-section-"][id$="__featured_collection_4fhY3w"]'
    );
    if (!rankRoot) {
      if (window.console) console.warn('[mebore] ranking section not found: __featured_collection_4fhY3w');
      return;
    }

    const cards = [...rankRoot.querySelectorAll('.grid__item')]
      .map(rankItem)
      .filter(record => record.link && record.item.item_id);

    observeOnce(rankRoot, () => {
      pushEvent('view_item_list', {
        item_list_id: 'mens_pdp_ranking',
        item_list_name: "MEN'S MEBORE ランキング",
        items: cards.map(record => record.item)
      });
    });

    rankRoot.addEventListener('click', event => {
      const link = event.target.closest('a.full-unstyled-link[href*="/products/"]');
      if (!link) return;
      const record = cards.find(candidate => candidate.link === link);
      if (!record) return;
      pushEvent('select_item', {
        item_list_id: 'mens_pdp_ranking',
        item_list_name: "MEN'S MEBORE ランキング",
        items: [record.item]
      });
    }, { capture: true });
  };

  const promotion = link => ({
    promotion_id: link.dataset.mnB5Handle || '',
    creative_slot: Number.parseInt(link.dataset.mnB5Slot || '0', 10),
    creative_name: 'mens_pdp_b5',
    season: link.closest('[data-mn-b5-root]')?.dataset.mnSeason || ''
  });

  const initB5 = () => {
    const root = document.querySelector('[data-mn-b5-root]');
    if (!root) return;
    const links = [...root.querySelectorAll('a[data-mn-b5-handle]')];
    observeOnce(root, () => links.forEach(link => pushEvent('view_promotion', promotion(link))));
    root.addEventListener('click', event => {
      const link = event.target.closest('a[data-mn-b5-handle]');
      if (link) pushEvent('select_promotion', promotion(link));
    }, { capture: true });
  };

  const initLine = () => {
    document.addEventListener('click', event => {
      const link = event.target.closest('a[data-mn-line="pdp_line_banner"]');
      if (!link) return;
      pushEvent('select_promotion', {
        promotion_id: 'pdp_line_banner',
        creative_name: 'mens_pdp_line'
      });
    }, { capture: true });
  };

  let initialized = false;
  const init = () => {
    if (initialized) return;
    initialized = true;
    initP1();
    initRanking();
    initB5();
    initLine();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
    window.addEventListener('load', init, { once: true });
    window.setTimeout(() => {
      if (document.readyState !== 'loading') init();
    }, 0);
  } else {
    init();
  }
})();
